// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step_title {
  font-size: 1.5rem;
}
/*  */
.stepCard {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/SCREENING/SECTIONS/STEPS/index.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA,KAAK;AACL;EACE,kBAAkB;AACpB","sourcesContent":[".step_title {\n  font-size: 1.5rem;\n}\n/*  */\n.stepCard {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
